import { render, staticRenderFns } from "./ModalPasswordRecoveryConfirm.vue?vue&type=template&id=1a80b74f"
import script from "./ModalPasswordRecoveryConfirm.vue?vue&type=script&lang=js"
export * from "./ModalPasswordRecoveryConfirm.vue?vue&type=script&lang=js"
import style0 from "./ModalPasswordRecoveryConfirm.vue?vue&type=style&index=0&id=1a80b74f&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports